(function () {
  'use strict';

  function initSeenOn(root) {
    var track = root.querySelector('[data-acc-ro-seen-track]');
    if (!track) return;

    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    var mobileQuery = window.matchMedia('(max-width: 767px)');

    function syncPause() {
      var shouldPause = reduceMotion.matches || !mobileQuery.matches;
      root.classList.toggle('is-paused', shouldPause);
    }

    function onVisibility() {
      if (document.hidden) {
        root.classList.add('is-paused');
      } else {
        syncPause();
      }
    }

    if (typeof reduceMotion.addEventListener === 'function') {
      reduceMotion.addEventListener('change', syncPause);
      mobileQuery.addEventListener('change', syncPause);
    } else if (typeof reduceMotion.addListener === 'function') {
      reduceMotion.addListener(syncPause);
      mobileQuery.addListener(syncPause);
    }

    document.addEventListener('visibilitychange', onVisibility);
    syncPause();
  }

  function initAll() {
    var roots = document.querySelectorAll('.ACC_RO_Homepage_19_02[data-acc-ro-seen-on]');
    for (var i = 0; i < roots.length; i += 1) {
      initSeenOn(roots[i]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();
